// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import InlineEditController from "./inline_edit_controller"
import GalleryPickerController from "./gallery_picker_controller"
import CarouselController from "./carousel_controller"
import AutoSubmitController from "./auto_submit_controller"
import FrontendHeaderController from "./frontend_header_controller"
import FrontendIndexSearchController from "./frontend_index_search_controller"
import FrontendMobileMenuController from "./frontend_mobile_menu_controller"
import FrontendUserMenuController from "./frontend_user_menu_controller"
import ModalController from "./modal_controller"
import SelectableRowController from "./selectable_row_controller"
import TipTapController from "./tiptap_controller"
import ToastController from "./toast_controller"
import TooltipController from "./tooltip_controller"
import UserMenuController from "./user_menu_controller"

application.register("carousel", CarouselController)
application.register("auto-submit", AutoSubmitController)
application.register("frontend-header", FrontendHeaderController)
application.register("frontend-index-search", FrontendIndexSearchController)
application.register("frontend-mobile-menu", FrontendMobileMenuController)
application.register("frontend-user-menu", FrontendUserMenuController)
application.register("inline-edit", InlineEditController)
application.register("gallery-picker", GalleryPickerController)
application.register("modal", ModalController)
application.register("selectable-row", SelectableRowController)
application.register("tiptap", TipTapController)
application.register("toast", ToastController)
application.register("tooltip", TooltipController)
application.register("user-menu", UserMenuController)
